import axios from "axios";
import JSONBIGINT from 'json-bigint'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router from '../router/index'
axios.defaults.baseURL = "/api";
import Vue from 'vue'
NProgress.configure({
  showSpinner: false
})

axios.defaults.transformResponse = [
  data => {
    // data json格式的字符串
    // 当后端没有响应的时候  转换会报错  捕获这个错误  处理：不去转换直接返回
    try {
      return JSONBIGINT.parse(data);
    } catch (e) {
      return data;
    }
  }
];

// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    NProgress.start()
    if (localStorage.getItem("token")) {
      config.headers.Token = localStorage.getItem("token");
      config.headers.uid = localStorage.getItem("uid");
      return config;
    }
    return config;
  },
  error => {
    if (!window.__POWERED_BY_QIANKUN__) {
      router.push("/");
    } else {
      Vue.prototype.$ReLogin()
    }
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    NProgress.done()
    //请求成功
    if (response.status == 200) {
      if (response.data.success) {
        if (
          response.data.message == "token过期" ||
          response.data.message == "缺少token"
        ) {
          //登陆超时跳转到登陆页面
          if (!window.__POWERED_BY_QIANKUN__) {
            router.push("/login");
          } else {
            Vue.prototype.$ReLogin()
          }
        }
        //请求成功
        return response;
      } else if (response.data.success && response.data.code == 0) {
        //用户未登录
        if (!window.__POWERED_BY_QIANKUN__) {
          router.push("/login");
        } else {
          Vue.prototype.$ReLogin()
        }
      } else {
        //请求失败 有可能是登陆
        return response;
      }
    }
  },
  function(error) {
    NProgress.done()
    // 对响应错误做点什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (!window.__POWERED_BY_QIANKUN__) {
            router.push("/login");
          } else {
            Vue.prototype.$ReLogin()
          }
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
